import { render, staticRenderFns } from "./PageDeliveryOrders.vue?vue&type=template&id=f49b2854&scoped=true&"
import script from "./PageDeliveryOrders.vue?vue&type=script&lang=ts&"
export * from "./PageDeliveryOrders.vue?vue&type=script&lang=ts&"
import style0 from "./PageDeliveryOrders.vue?vue&type=style&index=0&id=f49b2854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49b2854",
  null
  
)

export default component.exports